<template>
  <div class="neu-card-general-ctn">
    <div class="neu-card-general btn-min-height">
    <div class="subtitle-general mx-auto">
      <p v-html="paddedTitle"></p>
    </div>
      <span v-if="subtitle != undefined" v-html="paddedSubtitle">
      </span>
      <span v-if="subtitle2 != undefined" v-html="subtitle2">
      </span>
      <span v-if="subtitle3 != undefined" v-html="subtitle3">
      </span>
    </div>
  </div>
</template>

<script>
import es from '@/lang/es/public/views/opensalud-pacientes.json'
import en from '@/lang/en/public/views/opensalud-pacientes.json'

export default {
  name: 'neu-card-princing-professionals',
  i18n: {
    reviews: {
      es: es,
      en: en,
      mx: es
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    subtitle2: {
      type: String,
      required: false
    },
    subtitle3: {
      type: String,
      required: false
    },
    subtitleLines: Number,
    titleLines: Number
  },
  computed: {
    paddedTitle () {
      return this.titleLines ? `${this.title}${'<br>'.repeat(this.titleLines)}` : this.title
    },
    paddedSubtitle () {
      return this.subtitleLines ? `${'<br>'.repeat(this.titleLines)}${this.subtitle}${'&ensp;'}` : `${this.subtitle}${'&ensp;'}${'&ensp;'}`
    }
  }
}
</script>

<style lang="scss" scoped>

.img-icon {
        margin: auto;
        &.vertical {
          height: 150px;
          @include mobile {
            height: 150px;
          }
        }
        &:not(.vertical) {
          width: 100px;
          @include mobile {
            width: 150px;
          }
        }

        object-fit: cover;
      }
.neu-card-general-ctn {
  // position: relative;
  // display: flex !important;
  @include desktop {
    width: 35rem;
    opacity: 0.8;
    &:hover{
      opacity: 1;
    }    
  }
  @include tablets-lg {
    width: 25rem;
    opacity: 0.8;
    &:hover{
      opacity: 1;
    }    
  }
  @include desktop-sm {
    width: 35rem;
    opacity: 0.8;
    &:hover{
      opacity: 1;
    }    
  }

  align-items: center;
    transition-duration: 1s;


  .neu-card-general {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    background-color: transparent;
    // position: relative;
    transition-duration: 1s;
  
    &:hover {
    border: none;
  }
  cursor:default;
    .btn-more-info{
      font-size:13px;
      padding: .5rem 1.2rem
    }
    .icon-width-prof{
      width:3rem;
      @include desktop-sm{
          width:2rem;
        }
        @include mobile{
          width:1rem;
        }
      display: inline-block;
        margin-block-end: 0rem;
    -webkit-margin-after: 1rem;
    }
    .icon-width-360{
      width:4rem;
      margin-block-end: 1rem;
    -webkit-margin-after: 1rem;
      display: inline-block;
        @include desktop-sm{
          width:3rem;
        }
    }
    .icon-width-logo{
      width: 15rem;
      display: inline-block;
        margin-block-end: 1rem;
    -webkit-margin-after: 1rem;
    -webkit-margin-before: 1rem;

    }
    .div {
      padding: 0.5rem;
    }
    img{
      // position: absolute;
      width: 5rem;
      height: 5rem;
      transition-property: none;
    }

      .subtitle-general  {
        margin-bottom: 1rem;
        p {
          color: $blue;
          margin-top: 0;
          margin-bottom: 0.5rem;
        }
        p {
          font-size: 17px !important;
          @media screen and (max-width: 1098px) and (max-height: 620px) {
            font-size: 15px !important;
          }
          @include mobile {
            font-size: 15px !important;
          }
        }
        span {
          font-size: 17px !important;
          @media screen and (max-width: 1098px) and (max-height: 620px) {
            font-size: 15px !important;
          }
          @include mobile {
            font-size: 15px !important;
          }
        }
        @include desktop-sm{
          p {
            font-size: 0.8rem;
          }
          
          span {
            font-size: 0.8rem;
          }
        }
      
      
    text-align: center;

    p {
        @include mobile {
          width: 100%;
        }
       
      font-weight: bold;
      text-align: center;
      white-space: normal;
    }
  }
    // box-shadow: 0px -4px 35px #fff, 10px 10px 35px rgba(13,39,80,0.160784);
    // border: $border;
    // border-radius: $border-radius;

  }


}

</style>


// WEBPACK FOOTER //
// src/components/base/ui/NeuCardPricingProfessionals.vue